import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { selectWaterSourceKeyedById } from 'services/waterSource/selectors';
import { WaterSourceId } from 'services/waterSource/types';
import { OwnProps } from './index';

const selectWaterSourceId = (state: AppState, props: OwnProps): WaterSourceId =>
    props.waterSourceId;

const selectWaterSource = createDeepEqualSelector(
    selectWaterSourceKeyedById,
    selectWaterSourceId,
    (waterSourceState, waterSourceId) => get(waterSourceState, waterSourceId)
);

const selectWaterSourceName = createDeepEqualSelector(
    selectWaterSource,
    waterSourceState => get(waterSourceState, 'name', '')
);

const makeSelectWaterSourceName = (): typeof selectWaterSourceName =>
    selectWaterSourceName;

export { selectWaterSourceId, selectWaterSource, makeSelectWaterSourceName };
